import { useMemo } from 'react'

import { useJourneys } from './use-journeys.hook'
import { ISelectedIcon } from 'src/components'

const useJourneysSelection = (selectedJourneys: string[]) => {
  const { data: journeys } = useJourneys()

  const selectedJourneyIcons = useMemo<ISelectedIcon[]>(() => {
    if (!journeys?.data.length || !selectedJourneys.length) return []
    const id = selectedJourneys[0]

    const item = journeys.data.find((item) => item.id === id)

    if (!item) return []

    return [
      {
        subText: '#' + item.code,
        id: item.id,
        icon: item.image_medium || item.image,
        text: item.journey_name,
      },
    ]
  }, [selectedJourneys, journeys])

  return { selectedJourneyIcons }
}

export { useJourneysSelection }
